import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import axios from 'axios';
import { actions } from '_redux';
import { URL_SECURE_USER_DASHBOARD } from '_constants/urls';
import recaptchaSiteKey from '_constants/recaptcha';
import ReCAPTCHA from 'react-google-recaptcha';

import renderFieldGroup from '../utils/renderFieldGroup';
import './styles.scss';

const componentBaseClass = 'qoc-patient-login-form-container';

function validate(values = {}) {
  const errors = {};

  if (!values.loginId) {
    errors.loginId = 'Required';
  }

  if (!values.password) {
    errors.password = 'Required';
  }

  return errors;
}

function PatientLoginForm(props = {}) {
  const { logout } = props;
  const [loginError, setLoginError] = useState('');
  const reCaptchaRef = useRef();

  async function onSubmit(values, { setSubmitting }) {
    setLoginError('');
    setSubmitting(true);

    const reset = () => {
      reCaptchaRef.current.reset();
      setSubmitting(false);
    };

    const token = await reCaptchaRef.current.executeAsync();
    const url = `/login?j_rememberme=${values.remember}`;
    const bodyFormData = new FormData();
    let loginId = values.loginId;

    loginId = loginId.toLowerCase().trim();
    bodyFormData.append('j_username', loginId);
    bodyFormData.append('j_password', values.password);
    bodyFormData.append('recaptchaToken', token);

    axios
      .post(url, bodyFormData, {
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        console.log('asd res', res);

        axios
          .get('/api/session/profiles/user?UseCache=false&Refresh=false')
          .then(response => {
            reset();
            const { httpStatus } = response.data;
            if (httpStatus === '200') {
              localStorage.setItem('activatedUser', true);
              window.location.href = URL_SECURE_USER_DASHBOARD;
            }
          })
          .catch(() => {
            reset();
            setLoginError(
              'Your account still needs to be activated. Please check your email for next steps.'
            );
            const data = { emailAddress: loginId.toLowerCase().trim() };
            axios.post(`/api/logins/auth/activate`, data);
            localStorage.removeItem('activatedUser');
            logout();
          });
      })
      .catch(error => {
        reset();
        if (error.response) {
          const { data, status } = error.response;
          if (status === 401) {
            if (data.errors) {
              const { errors } = data;
              const { reason } = errors[0];
              setLoginError(reason);
            } else {
              setLoginError('Invalid username/password');
            }
          }
        } else if (error.request) {
          setLoginError('Internal Server Error');
        } else {
          setLoginError('Login failed');
        }
      });
  }

  const initialValues = { loginId: '', password: '', remember: false };

  return (
    <div className={componentBaseClass}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={validate}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting
        }) => (
          <form
            className={`${componentBaseClass}__login-form`}
            onSubmit={handleSubmit}
          >
            <div className="form-group">
              <p className={`${componentBaseClass}--label`}>Username (Email)</p>
              {renderFieldGroup({
                id: 'loginId',
                onBlur: handleBlur,
                onChange: handleChange,
                type: 'text',
                value: values.loginId,
                valueError: errors.loginId,
                valueTouched: touched.loginId
              })}
            </div>
            <div className="form-group">
              <p className={`${componentBaseClass}--label`}>Password</p>
              {renderFieldGroup({
                id: 'password',
                onBlur: handleBlur,
                onChange: handleChange,
                type: 'password',
                value: values.password,
                valueError: errors.password,
                valueTouched: touched.password
              })}
            </div>
            <div>
              {renderFieldGroup({
                id: 'remember',
                label: 'Remember me',
                onBlur: handleBlur,
                onChange: handleChange,
                type: 'checkbox',
                placeholder: '',
                value: values.remember,
                valueError: errors.remember,
                valueTouched: touched.remember
              })}
            </div>
            {loginError ? (
              <p className="form-field-error">{loginError}</p>
            ) : null}
            <ReCAPTCHA
              sitekey={recaptchaSiteKey}
              size="invisible"
              ref={reCaptchaRef}
            />
            <button
              className={`${componentBaseClass}--submit`}
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Processing...' : 'Log in'}
            </button>
          </form>
        )}
      </Formik>
    </div>
  );
}

PatientLoginForm.propTypes = {
  logout: PropTypes.func.isRequired
};
PatientLoginForm.defaultProps = {};

function mapDispatchToProps(dispatch) {
  return {
    logout: props => dispatch(actions.authentication.logout(props))
  };
}

export default connect(
  null,
  mapDispatchToProps
)(PatientLoginForm);
